import { withAuth0, withAuthenticationRequired } from '@auth0/auth0-react';
import OrderBaseList from 'components/Tables/OrderBaseList';

export default withAuth0(withAuthenticationRequired(class TomorrowsOrders extends OrderBaseList {
  getListParams = () => ({ tomorrows_orders: 'Y', show_all: 'true' });

  getPageTitle = () => "Tomorrow's Orders";

  contentDisplay = () => this.getInnerTableContent();

  getTableClassSettings = () => 'wm_short_table';

  getStorageName = () => 'otto_my_wm_tomorrows_orders_list';
}));
